import { render, staticRenderFns } from "./Des.vue?vue&type=template&id=92bd3248&scoped=true"
import script from "./Des.vue?vue&type=script&lang=ts"
export * from "./Des.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Des.vue?vue&type=style&index=0&id=92bd3248&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "92bd3248",
  "0a8596cc"
  
)

export default component.exports